import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  margin-bottom: 3rem;
  float: left;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;
